import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'View All', href: '/categories' },
  { label: 'Business Cards', href: '/categories/business-cards' },
  { label: 'Stationery & Letterheads', href: '/categories/letterheads' },
  { label: 'Banners & Posters', href: '/categories/banners-posters' },
  { label: 'Stamps & Ink', href: '/categories/stamps-seals' },
  { label: 'Labels & Stickers', href: '/categories/labels-stickers' },
  { label: 'Clothing & Apparel', href: '/categories/clothing-apparel' },
  { label: 'Mugs & Gifts', href: '/categories/mugs-gifts' },
  { label: 'Photo Products', href: '/categories/photo-products' },
  { label: 'Custom Packaging', href: '/categories/custom-packaging' },
];

export default function MainNav() {
  const pathname = useLocation().pathname;

  return (
    <nav className="main-nav">
      <div className="nav-inner">
        {navLinks.map((link) => (
          <Link
            key={link.href}
            to={link.href}
            className={pathname === link.href ? 'active' : ''}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
